import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import { Link } from 'dibs-elements/exports/Link';

const UserAgreement: FC = () => (
    <FormattedMessage
        id="DealerApplicationForm.businessDetails.disclaimer"
        defaultMessage="By entering your email, you agree to our {userAgreementLink} and {privacyPolicyLink} and opt-in to receive seller marketing emails."
        values={{
            userAgreementLink: (
                <Link
                    dataTn="user-agreement-link"
                    href="/about/user-agreement/"
                    target="_blank"
                    buyerLinkType="invertedLink"
                    underline="underline"
                >
                    <FormattedMessage
                        id="DealerApplicationForm.userAgreement"
                        defaultMessage="User Agreement"
                    />
                </Link>
            ),
            privacyPolicyLink: (
                <Link
                    dataTn="privacy-policy-link"
                    href="/about/privacy-policy/"
                    target="_blank"
                    buyerLinkType="invertedLink"
                    underline="underline"
                >
                    <FormattedMessage
                        id="DealerApplicationForm.privacyPolicy"
                        defaultMessage="Privacy Policy"
                    />
                </Link>
            ),
        }}
    />
);

export default UserAgreement;
